export const formatDateToKorean = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  
  const ampm = hours < 12 ? '오전' : '오후';
  const hour12 = hours % 12 || 12;
  
  return `${year}년 ${month}월 ${day}일 ${ampm} ${hour12}시 ${minutes}분 ${seconds}초 UTC+9`;
};

export const formatSummary = (text) => {
  if (!text) return '요약을 불러오는 중...';
  
  try {
    const lines = text.split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    if (lines.length === 0) {
      return '요약 내용이 없습니다.';
    }

    let formatted = '';
    let currentSection = '';
    
    lines.forEach(line => {
      if (line.startsWith('#')) {
        currentSection = line.toLowerCase();
        formatted += `${line}\n\n`;
      }
      else if (/^\d+\./.test(line)) {
        formatted += `${line}\n`;
      }
      else if (line.startsWith('-')) {
        formatted += `${line}\n`;
      }
      else {
        if (currentSection.includes('핵심 메시지')) {
          formatted += `**${line}**\n\n`;
        } else {
          formatted += `${line}\n\n`;
        }
      }
    });

    formatted = formatted.replace(/\n{3,}/g, '\n\n').trim();
    return formatted;
  } catch (error) {
    console.error('Error formatting summary:', error);
    return '요약을 표시하는 중 오류가 발생했습니다.';
  }
};

export const formatDetailContent = (chapters) => {
  if (!chapters || !Array.isArray(chapters) || chapters.length === 0) {
    return '상세 내용을 불러오는 중...';
  }

  let content = '## 목차\n\n';
  
  try {
    chapters.forEach((chapter, idx) => {
      if (chapter && chapter.title) {
        content += `${idx + 1}. [${chapter.title}](#chapter-${idx + 1}) ${chapter.startTime || ''}\n`;
      }
    });

    content += '\n---\n\n';

    chapters.forEach((chapter, idx) => {
      if (chapter && chapter.title) {
        content += `### ${idx + 1}. ${chapter.title} ${chapter.startTime ? `(${chapter.startTime})` : ''}\n\n`;
        
        if (chapter.bullets && Array.isArray(chapter.bullets)) {
          chapter.bullets.forEach(bullet => {
            content += `- ${bullet}\n`;
          });
          content += '\n';
        }
      }
    });

    return content;
  } catch (error) {
    console.error("Error formatting chapters:", error);
    return '상세 내용을 표시하는 중 오류가 발생했습니다.';
  }
};

export const makeChaptersMarkdown = (chapters) => {
  if (!chapters || !Array.isArray(chapters) || chapters.length === 0) {
    return '';
  }

  let toc = '## 목차\n';
  let body = '';
  
  try {
    chapters.forEach((ch, idx) => {
      if (!ch || !ch.title || !ch.content) return;
      
      toc += `${idx + 1}. [${ch.title}](#chapter-${idx + 1})\n`;
      body += `\n---\n\n### <span id="chapter-${idx + 1}">${ch.title}</span>\n`;
      
      if (Array.isArray(ch.content)) {
        ch.content.forEach(section => {
          if (!section || !section.main) return;
          
          body += `- ${section.main}\n`;
          if (Array.isArray(section.subs)) {
            section.subs.forEach(sub => {
              if (sub) body += `  - ${sub}\n`;
            });
          }
        });
      }
    });
    
    return `${toc}\n${body}`;
  } catch (error) {
    console.error("Error in makeChaptersMarkdown:", error);
    return '';
  }
}; 